import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";

import { PropsWithClassName } from "../../common/types/PropsWithClassName";
import { fetchTeams } from "./teamsApi";
import { Team } from "./Team";

interface GroupedTeams {
  name: string;
  id: string;
  items: Team[];
}

interface GroupedTeamsDropdownProps extends PropsWithClassName {
  showClear?: boolean;
  value?: string;
  disabled?: boolean;
  onChange: (teamId?: string) => void;
}

export default function GroupedTeamsDropdown({ className, showClear, value, disabled, onChange }: GroupedTeamsDropdownProps) {
  const [groupedTeams, setGroupedTeams] = useState<GroupedTeams[]>([]);
  const selectedTeam = groupedTeams.flatMap((group) => group.items).find((team) => team.id === value);

  useEffect(() => {
    const doFetchTeams = async () => {
      const teams = await fetchTeams();
      const grouped: any = Object.values(
        teams.reduce<Record<string, GroupedTeams>>((acc, team: Team) => {
          if (!acc[team.departmentId]) {
            acc[team.departmentId] = {
              id: team.departmentId,
              name: `${team.departmentName}`,
              items: [],
            };
          }
          acc[team.departmentId].items.push({
            id: team.id,
            departmentId: team.departmentId,
            departmentName: team.departmentName,
            name: team.name,
            users: team.users || [],
          });
          return acc;
        }, {})
      );
      setGroupedTeams(grouped);
    };

    doFetchTeams();
  }, []);

  return (
    <Dropdown
      className={`${className}`}
      placeholder="Grup"
      optionLabel="name"
      optionGroupLabel="name"
      optionGroupChildren="items"
      options={groupedTeams}
      showClear={showClear}
      disabled={disabled}
      value={selectedTeam}
      onChange={(e) => onChange(e.value?.id)}
    />
  );
}
